// /src/data/projects.js
import sideseatImg from './sideseat-cover.svg';
import hibikiImg from './hibiki-cover.svg';
import langlawImg from './langlaw-cover.svg';
import uptrendImg from './uptrend-cover.svg';
import agentScaffoldingImg from './agent-cover.svg';
import aiAgentWorkflowImg from './ai-agent-workflow-cover.svg';

export const projects = [
  {
    id: 'ai-agent-workflow',
    title: 'AI Agent Workflow',
    period: '2025 ~ Present',
    description:
      'ReAct 패턴 기반 멀티 에이전트 플랫폼. 의도 분석 → 전문 에이전트 자동 라우팅 → Plan-and-Execute 실행 구조로 복잡한 업무를 처리합니다. MCP(Model Context Protocol)로 외부 도구를 코드 수정 없이 연결하며, Qdrant 벡터 DB와 BGE-M3 임베딩 기반 RAG, JWT/Fernet 세션 보안을 포함한 FastAPI + React TypeScript 풀스택입니다.',
    stack: [
      'LangChain',
      'LangGraph',
      'MCP',
      'FastAPI',
      'Python',
      'React',
      'TypeScript',
      'PostgreSQL',
      'Qdrant',
      'DSPy',
    ],
    link: null,
    imageUrl: aiAgentWorkflowImg,
  },
  {
    id: 'sideseat',
    title: 'SideSeat',
    period: '2026.01 ~ Present',
    description:
      '혼자 가기 애매한 순간을 연결하는 인증 기반 동행·공간 탐색 플랫폼입니다. Next.js 프론트(Cloudflare Pages)와 Cloudflare Workers 기반 Worker API, Supabase(Postgres)로 동행·장소 데이터를 다루며 카카오 로컬 API로 장소 검색을 연동할 수 있습니다. sideseat.co.kr',
    stack: [
      'Next.js',
      'React',
      'Cloudflare Pages',
      'Cloudflare Workers',
      'Supabase',
      'NextAuth.js',
      'REST API',
      'Kakao Local API',
      'Wrangler',
    ],
    link: 'https://sideseat.co.kr/',
    imageUrl: sideseatImg,
  },
  {
    id: 'agent',
    title: 'Agent Control Plane',
    period: '2026.03 ~ Present',
    description:
      'sideseat용 에이전트 컨트롤 플레인(Agent Control Plane)입니다. 에이전트는 DB에 직접 붙지 않고, Object·Link·Action 온톨로지(Ontology)와 역할 기반 툴 레지스트리(tool registry), Worker API(WORKER_BASE_URL)만 거치도록 경계를 뒀습니다. Think→Act→Observe 루프, 온톨로지·워크플로(workflow)를 그리는 Vite·React Studio, Docker 기반 ops·backend·support 역할 분리까지 한 저장소에서 다룹니다.',
    stack: [
      'TypeScript',
      'React',
      'Vite',
      'Node.js',
      'Docker',
      'Ontology',
      'Worker API',
      'Ollama',
      'Anthropic',
    ],
    link: 'https://github.com/calicorone/agent-control-plane',
    imageUrl: agentScaffoldingImg,
  },
  {
    id: 'hibiki',
    title: 'hibiki',
    period: '2026.03 ~ Present',
    description:
      'GPT-2 124M을 처음부터 구현·학습하는 저장소입니다. Karpathy 스타일 학습 파이프(train_gpt2.py)와 Vite+React 웹 UI로 빌드 명령 생성, 파이프라인·아키텍처 시각화, 단계별 학습 가이드 및 Attention Is All You Need 요약(KO/EN)을 제공합니다.',
    stack: ['Python', 'PyTorch', 'Vite', 'React', 'GPT-2', 'BPE', 'KaTeX'],
    link: 'https://github.com/calicorone/hibiki',
    imageUrl: hibikiImg,
  },
  {
    id: 'langlaw',
    title: 'LangLaw',
    period: '2025.07 ~ 2025.08',
    description:
      '사건 설명을 입력받아 관련 법령과 판례를 자동 검색해주는 생성형 AI 법률 보조 서비스입니다. LangChain 기반 RAG 구조와 국가법령정보센터 Open API를 활용하며, 로컬 벡터 DB 및 판례 추천 기능을 통합할 예정입니다.',
    stack: [
      'LangChain',
      'Python',
      'RAG',
      '국가법령정보센터 API',
      'FAISS/Chroma',
      'React',
      'Supabase',
      'Streamlit',
    ],
    link: 'https://github.com/calicorone/Langraw',
    imageUrl: langlawImg,
  },
  {
    id: 'uptrend',
    title: 'Uptrend',
    period: '2026.01 ~ Present',
    description:
      'Python 기반 알고리즘 트레이딩 시스템입니다. 데이터 수집(yfinance/FDR/키움), 백테스팅, 전략 모듈, 리스크 관리(손절/익절/최대낙폭), 포트폴리오 추적 및 리포트 자동 생성 기능을 제공합니다.',
    stack: [
      'Python',
      'Pandas',
      'NumPy',
      'yfinance',
      'FinanceDataReader',
      'Kiwoom OpenAPI/REST',
      'Backtesting',
      'Risk Management',
    ],
    link: 'https://github.com/calicorone/algorithm_trading',
    imageUrl: uptrendImg,
  },
];
